export default "__VITE_ASSET__DI61tsMH__"